import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { DecimalPipe } from '@angular/common';
import { Injector } from '@angular/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChargingStationDto } from '../../../dto/chargingStationDto';
import { TableColumn } from '@models/tableColumn';
import { TableFilter } from '@models/tableFilter';
import { TableOptions } from '@models/tableOptions';
import { DEDatePipe } from '../../../pipes/de-date.pipe';
import { ThousandPipe } from '../../../pipes/thousand.pipe';
import { RouteDataService } from '../../../services/route-data/route-data.service';
import { FormService } from '@services/form/form.service';
import { plainToClass } from 'class-transformer';
import { ChargingStationsService } from '@services/entity/charging-stations.service';


@Component({
  selector: 'app-dashboard-offlineSince',
  templateUrl: './dashboard-offlineSince.component.html',
  styleUrls: ['./dashboard-offlineSince.component.scss']
})
export class DashboardOfflineSinceComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {

  public className = 'DashboardOfflineSinceComponent';
  public activeComponentClassName: string = 'DashboardOfflineSinceComponent';

  public entities: ChargingStationDto[];

  public tableColumns: TableColumn[] = [
    { columnDescription: 'ID', property: 'id' },
    { columnDescription: 'Name', property: 'name' },
    { columnDescription: 'Kunde', property: 'customer.name' },
    { columnDescription: 'offline seit', property: 'offlineSince', options: { columnPipe: { pipe: new DEDatePipe() } } },
    { columnDescription: 'gemeldet', property: 'displayOffLineReported', options: { 'isBoolean': true,  } },
  ];

  public tableOptions: TableOptions = { hideActions: true, hideSearch: true, rowRouterLink: '/operator/chargingstation/{id}' };

  constructor(
    public chargingstationservice: ChargingStationsService,
    public formService: FormService,
    injector: Injector) {
    super(chargingstationservice, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tableFunctions.sortColumn = 'offlineSince';
    this.tableFunctions.sortDirection = 'desc';
  }

  async initializeEntities() {
    this.chargingstationservice.getOfflineChargeStations().subscribe(result => {
      this.entities = plainToClass(ChargingStationDto, result)
      super.setupTable();
      this.mapReported();
    }, error => {});
  }

  mapReported() {
    this.entities.forEach(f => {
      let reported = ""
      if (f.offlineStatusReported) {
        reported = `1` }
      else { reported = `0` }
      f.displayOffLineReported = reported;
    })
  }

  matches(entity: ChargingStationDto, term: string) {
    var datePipe = new DEDatePipe();
    var timestamp_offline = datePipe.transform(entity.offlineSince);

    return entity.name?.toLocaleLowerCase().includes(term.toLowerCase())
      || entity.id?.toLowerCase().includes(term.toLowerCase())
      || entity.name?.toLowerCase().includes(term.toLowerCase())
      || entity.customer?.name?.toLowerCase().includes(term.toLowerCase())
      || timestamp_offline?.includes(term.toLowerCase())

  }

}
